import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { uniq, compact } from 'lodash';
//
import { showNotification } from 'utils/appUtils';
import TagsTreeSelector from './TagsTreeSelector';
import { useContentTags } from 'lib/content-tags';

const TagIdsTreeSelector = (props) => {
  const { onChange, value, ...restOfTheProps } = props;
  const { contentTagsMapByTitle } = useContentTags();
  const [searchText, setSearchText] = useState('');

  const onChangeWrapper = (value) => {
    const contentTagIds = value.map((tag) => tag.value);
    onChange(contentTagIds);
    setSearchText('');
  };

  const parsedValue = (value || []).map((v) => ({ value: v }));

  return (
    <TagsTreeSelector
      searchValue={searchText}
      onSearch={(searchValue) => {
        if (!searchValue.includes(',')) {
          setSearchText(searchValue);
          return;
        }

        const tagNames = compact(searchValue.split(',').map((tag) => tag.trim()));
        const contentTagIds = [];
        const notFoundTagNames = [];

        tagNames.forEach((tagName) => {
          const contentTag = contentTagsMapByTitle[tagName];
          if (contentTag) {
            contentTagIds.push(contentTag._id);
          } else {
            notFoundTagNames.push(tagName);
          }
        });

        if (notFoundTagNames.length) {
          showNotification(
            'error',
            `The following tags were not found: ${notFoundTagNames.join(', ')}`
          );
        }

        onChange(value ? uniq([...value, ...contentTagIds]) : contentTagIds);
        setSearchText('');
      }}
      onChange={onChangeWrapper}
      value={parsedValue}
      {...restOfTheProps}
    />
  );
};

TagIdsTreeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.array.isRequired,
};

export { TagIdsTreeSelector };
